module.exports = __webpack_public_path__ + "media/berlin/overview-map-berlin-92823628.webp";